import React from 'react';

export type NcExternalLinkPropsT = {
  children: React.ReactNode;
  href: string;
};

export const NcExternalLink = ({
  href,
  children,
}: NcExternalLinkPropsT) => {
  return (
    <a
      href={href}
      rel="noreferrer noopener"
      target="_blank"
    >
      {children}
    </a>
  );
};
